export const baseURL = "https://admin.rbah.live/";
export const secretKey = "Rbah_2026_SecureKey_X9A7K2";
export const projectName = "rbah";
